const tpDailyDc = {
  dc: 'DC',
  assessMonth: '考核月份',
  assessMonthStart: '开始月份',
  assessMonthEnd: '结束月份',
  carrierCode: '承运商代码',
  serviceProvider: '服务商',
  assessItem: '考核项目',
  versionNo: '版本号',
  category: '分类',
  assessContent: '考核内容',
  citationClause: '援引条款',
  score: '分数',
  occurCount: '发生次数',
  adjustScore: '加减分',
  breachExample: '违约示例描述',
  statCategory: '统计类别',
  createTime: '创建时间',
  msg: {}
};
export default tpDailyDc;



// WEBPACK FOOTER //
// ./src/page/assess/tpDailyDc/lang/tpDailyDc.zh.js